<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      Inventory
      <i class="fa fa-fw fa-question-circle" v-tooltip data-placement="right" title="Pull product from supplier"></i>
    </div>
    <div class="panel-body">
      <div class="form-inline form-inline--better-spaced">
        <div class="form-group">
          <label>Supplier</label>
          <select class="form-control" v-model="supplierId" :disabled="loading">
            <option :value="null">Sellect Supplier</option>
            <option v-for="(opt, key) in supplierOptions" :key="key" :value="opt.value" v-html="opt.label"></option>
          </select>
        </div>
        <div class="form-group">
          <label>Reference Type</label>
          <select class="form-control" v-model="referenceType" :disabled="loading">
            <option value="product_id">Product ID</option>
            <option value="inventory_id">Inventory ID</option>
            <option value="part_number">Part Number</option>
          </select>
        </div>
        <div class="checkbox">
          <label>
            <input type="checkbox" v-model="asBatch" :disabled="loading" />
            Request as Batch
          </label>
        </div>
      </div>
      <div class="form-group" v-if="asBatch">
        <label>Reference Numbers (separated by comma)</label>
        <textarea class="form-control" v-model="referenceNumbers" rows="3" :disabled="loading"></textarea>
      </div>
      <div class="form-group" v-else>
        <label>Reference Number (one reference at a time)</label>
        <input type="text" class="form-control" v-model="referenceNumbers" :disabled="loading" />
      </div>
      <div class="form-inline form-inline--better-spaced">
        <div class="form-group">
          <button type="button" class="btn btn-default" @click="viewPayload" :disabled="!formIsOk || loading"><i class="fa fa-fw fa-eye"></i> View Payload</button>
        </div>
        <div class="form-group">
          <button type="button" class="btn btn-default" @click="applyPayload" :disabled="!formIsOk || loading"><i class="fa fa-fw fa-refresh"></i> Sync</button>
        </div>
        <div class="form-group">
          <button type="button" class="btn btn-default" @click="clearForm" :disabled="(!formIsOk || loading) && !payload"><i class="fa fa-fw fa-times"></i> Clear</button>
        </div>
      </div>
      <div v-if="!!response">
        <h5>Response <a href="#" @click.prevent="toggleResponseView">{{ showResponse ? 'Hide' : 'Show' }}</a></h5>
        <pre v-if="showResponse">{{ response }}</pre>
      </div>
      <div v-if="!!payload">
        <h5>Payload <a href="#" @click.prevent="togglePayloadView">{{ showPayload ? 'Hide' : 'Show' }}</a></h5>
        <pre v-if="showPayload">{{ payload }}</pre>
      </div>
    </div><!-- .panel-body -->
  </div><!-- .panel -->
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ApiResponseMixin from '@/plugin/mixin/api-response'
import Tooltip from '@/plugin/directive/tooltip'

export default {
  name: 'sync-by-inventory-form-component',
  data() {
    return {
      referenceType: null,
      referenceNumbers: null,
      supplierId: null,
      asBatch: null,
      showResponse: true,
      showPayload: true,
      response: null,
    }
  },
  computed: {
    ...mapState('dropship/seller/syncInventory', {
      supplierOptions: 'supplierOptions',
      payload: 'payloadByProduct'
    }),
    ...mapGetters('dropship/seller/syncInventory', {
      isRequestingServer: 'isRequestingServer'
    }),
    formIsOk() {
      return this.referenceType && this.referenceNumbers && this.supplierId
    },
    loading() {
      return this.isRequestingServer
    }
  },
  methods: {
    toggleResponseView() {
      this.showResponse = !this.showResponse
    },
    togglePayloadView() {
      this.showPayload = !this.showPayload
    },
    viewPayload() {
      this.response = null

      this.showPayload = true
      this.$store.dispatch(
        'dropship/seller/syncInventory/viewPayloadByProduct',
        {
          supplierId: this.supplierId,
          referenceType: this.referenceType,
          referenceNumbers: this.referenceNumbers,
          asBatch: this.asBatch,
        }
      )
    },
    async applyPayload() {
      this.response = null

      try {
        const response = await this.$store.dispatch(
          'dropship/seller/syncInventory/applyPayloadByProduct',
          {
            supplierId: this.supplierId,
            referenceType: this.referenceType,
            referenceNumbers: this.referenceNumbers,
            asBatch: this.asBatch,
          }
        )
        if (response) {
          this.$alertify.success('Product synchronized')
        } else {
          this.$alertify.error('Product NOT synchronized')
        }
        this.response = response
      } catch (reason) {
        if (this.isResponseError(reason)) {
          this.raiseErrorMessage(reason)
        } else {
          this.$alertify.error('An error was raised while requesting to apply payload.  Message: ' + reason)
        }
        this.response = reason
      }
    },
    clearForm() {
      this.referenceType = null
      this.referenceNumbers = null
      this.supplierId = null
      this.showPayload = true
      this.response = null
      this.$store.dispatch('dropship/seller/syncInventory/clearPayloadByProduct')
    }
  },
  directives: {
    tooltip: Tooltip
  },
  mixins: [
    ApiResponseMixin
  ]
}
</script>
